import { AxiosInstance } from 'axios';

import { ScaleType } from '../../../store/entities/scaleType/scaleType.types';

const ScaleTypeServiceFactory = ({ HTTPBase }: { HTTPBase: AxiosInstance }) => {
  return {
    getScaleTypeList: (includeNotActive: boolean): Promise<ScaleType[]> =>
      HTTPBase.get(`scaletypes?includeNotActive=${includeNotActive}`).then((res) => res.data),
  };
};

export default ScaleTypeServiceFactory;
